/**
 * Session Warning Modal
 * Shown shortly before an idle-triggered auto-logout, with a live countdown
 * and a way to stay logged in.
 */

interface SessionWarningModalProps {
  isOpen: boolean
  remainingSeconds: number
  onStayLoggedIn: () => void
  onLogoutNow: () => void
}

export function SessionWarningModal({
  isOpen,
  remainingSeconds,
  onStayLoggedIn,
  onLogoutNow,
}: SessionWarningModalProps) {
  if (!isOpen) return null

  const minutes = Math.floor(remainingSeconds / 60)
  const seconds = remainingSeconds % 60
  const timeLabel = `${minutes}:${seconds.toString().padStart(2, '0')}`

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-lg shadow-2xl max-w-sm w-full p-6">
        <h2 className="text-lg font-heading font-bold text-navy mb-2">Still there?</h2>
        <p className="text-gray-600 mb-6">
          You'll be logged out due to inactivity in{' '}
          <span className="font-semibold text-accent">{timeLabel}</span>.
        </p>
        <div className="flex gap-3 justify-end">
          <button
            onClick={onLogoutNow}
            className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 font-medium transition-colors"
          >
            Log Out Now
          </button>
          <button
            onClick={onStayLoggedIn}
            className="px-4 py-2 rounded-lg bg-primary text-white hover:bg-primary/90 font-medium transition-colors"
          >
            Stay Logged In
          </button>
        </div>
      </div>
    </div>
  )
}

export default SessionWarningModal
